var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpsLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 -0.25 36 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#595555;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#FAB80A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: "1%",
    stroke: "white",
    className: "st0",
    d: "M18,0c10,0,18,8,18,18c0,13.5-18,26.7-18,26.7S0,31.5,0,18C0,8,8,0,18,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.7,14.9L18.7,14.9c-0.3,0-0.7,0.1-0.9,0.2v7.7c0.2,0.1,0.5,0.2,0.8,0.2c1.4,0,2.1-1.3,2.1-4.1 C20.8,16,20.2,14.9,18.7,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.5,22.6c-0.3,0.2-0.7,0.3-1.2,0.3c-1.2,0-1.3-1.1-1.3-1.8v-8H6.5V21c0,2.7,1.3,4,3.8,4c1.5,0,2.8-0.4,3.8-1 V13.1h-2.5V22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.7,12.8c-1.4,0-2.5,0.3-3.4,0.9v16.4h2.5v-5.3c0.3,0.1,0.6,0.1,1.1,0.1c2.8,0,4.4-2.5,4.4-6.2 C23.4,15.1,21.7,12.8,18.7,12.8z M18.7,22.9c-0.3,0-0.6-0.1-0.8-0.2v-7.7c0.2-0.1,0.6-0.2,0.9-0.2v0c1.5,0,2.1,1.2,2.1,4 C20.8,21.6,20.1,22.9,18.7,22.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "6.5,13.1 6.5,13.1 6.5,13.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28,17.9c-0.9-0.6-1.7-0.9-1.7-1.8c0-0.9,0.8-1.2,1.5-1.2c0.9,0,1.7,0.5,2.3,1v-2.2c-0.4-0.3-1.4-0.9-2.8-0.8 v0c-1.7,0-3.4,1.2-3.4,3.3c0,1.3,0.4,2.3,2.5,3.6c1.1,0.7,1.6,1.1,1.6,1.9c0,0.9-0.6,1.4-1.5,1.4c-0.8,0-1.8-0.5-2.4-1v2.3 c0.8,0.5,1.8,0.8,2.8,0.8c2.5,0,3.6-1.8,3.6-3.4C30.5,20.2,30.1,19.1,28,17.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsLogo);
export default __webpack_public_path__ + "static/media/ups_logo.d4552817046c45c78c32a3969f9e68a7.svg";
export { ForwardRef as ReactComponent };